// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"47bc356f","703":"1cb49474"}[chunkId] + ".chunk.css";
};